export const stripPhoneNumberFormatting = (phoneNumber: string): string => (
  phoneNumber.toString().replace(/[\s()-]/g, '')
);

export const sanitizePhoneNumber = (phoneNumber: string, prefix: string) => (
  prefix + stripPhoneNumberFormatting(phoneNumber)
);

export default { sanitizePhoneNumber, stripPhoneNumberFormatting };
